/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useIntl } from "react-intl";
import Layout from "../components/features/Default/layout/layout";

export default function Term() {
  const intl = useIntl();
  return (
    <Layout pageProps={{ title: intl.formatMessage({ id: "footer.policy.termsofuse" }) }}>
      <div className="box-cover sm:w-screen md:w-full">
        <h1 className="text-center text-[22px]">
          <b>QUY ĐỊNH SỬ DỤNG</b>
        </h1>
        <p>
          <i>(Cập nhật ngày 01/10/2021)</i>
        </p>
        <h4>
          XIN VUI LÒNG ĐỌC KỸ CÁC QUY ĐỊNH DƯỚI ĐÂY VÌ NHỮNG ĐIỀU KHOẢN NÀY ĐƯỢC
          ÁP DỤNG CHO VIỆC BẠN SỬ DỤNG CÁC DỊCH VỤ VÀ ỨNG DỤNG MOBILE CỦA
          QSOFT.VN.
        </h4>
        <br />
        <span className="font-semibold text-[18px]">
          1. Các thay đổi với jlptup.com
        </span>
        <br />
        Chúng tôi, với toàn quyền hạn của mình và vào bất cứ lúc nào được quyền
        bổ sung, sửa đổi hay xóa bỏ bất kỳ thông tin nào cũng như thay đổi giao
        diện, sự trình bày, thành phần hoặc chức năng, nội dung của trang web
        này bao gồm bất kỳ khoản mục nào mà không cần báo trước.
        <br />
        <br />
        <span className="font-semibold text-[18px]">2. Thay đổi quy định</span>
        <br />
        Chúng tôi có toàn quyền thay đổi quy định mà không cần báo trước. Với
        việc tiếp tục sử dụng jlptup.com sau những sửa đổi đó, bạn mặc nhiên
        đồng ý chấp hành các sửa đổi trong quy định.
        <br />
        <br />
        <span className="font-semibold text-[18px]">3. Hành vi của bạn.</span>
        <br />
        <br />
        Bận thừa nhận rằng tất cả thông tin hoặc dữ liệu thuộc bất kỳ dạng nào,
        dù là văn bản, phần mềm, mã, nhạc hoặc âm thanh, ảnh hoặc đồ họa, video
        hoặc các chất liệu khác Nội dung', được bạn hoặc “người có tài khoản
        người dùng bị sử dụng” chia sẻ công khai và rộng rãi trên diễn đàn hoặc
        tại các khu vực trên website cho phép bạn chia sẻ nội dung dưới bất kỳ
        định dạng nào, sẽ hoàn toàn thuộc trách nhiệm của bạn hoặc người có tài
        khoản người dùng bị sử dụng. Bạn thừa nhận rằng website của chúng tôi có
        thể đưa bạn đến Nội dung có thể không phù hợp hoặc phản cảm theo nhận
        định của cá nhân bạn. Mặc dù vậy, chúng tôi sẽ không chịu bất kỳ trách
        nhiệm với bạn trong bất cứ phương diện nào nào về Nội dung của trang web
        hay bất cứ tổn thất hoặc lỗi nào có liên quan.
        <br />
        <br />
        Khi sử dụng website này và các dịch vụ được cung cấp, bạn hoàn toàn đồng
        ý rằng:
        <br />
        <br />
        Bạn sẽ không xâm phạm, xâm nhập, tiếp cận, sử dụng hay tìm cách xâm
        phạm, xâm nhập, tiếp cận hoặc sử dụng bất kỳ phần nào trong máy chủ của
        chúng tôi, và/ hoặc bất kỳ khu vực dữ liệu nào nếu không được chúng tôi
        cho phép;
        <br />
        <br />
        Bạn không được quyền hoặc có các hành động nhằm hạn chế hoặc cấm đoán
        bất kỳ người dùng nào khác sử dụng và thưởng thức website jlptup.com;
        <br />
        <br />
        Bạn sẽ không gửi lên hoặc truyền phát bất kỳ thông tin bất hợp pháp, lừa
        gạt, bôi nhọ, sỉ nhục, tục tĩu, khiêu dâm, xúc phạm, đe dọa, lăng mạ,
        thù hận, kích động… hoặc trái với chuẩn mực đạo đức chung của xã hội
        thuộc bất kỳ loại nào, bao gồm cả việc truyền bá hay khuyến khích những
        hành vi có thể cấu thành tội phạm hay vi phạm bất cứ điều khoản nào của
        luật pháp địa phương, quốc gia hay quốc tế. Chúng tôi tôn trọng quyền tự
        do ngôn luận, nhưng cũng bảo lưu việc có toàn quyền lược bớt, hoặc xoá
        bỏ một phần hoặc toàn bộ các bài viết của bạn nếu xét thấy bài viết hoặc
        bất kỳ thông tin gì gửi lên vi phạm những điểm nêu trên, bất kể việc vi
        phạm đó là rõ ràng hay chỉ là hàm ý.
        <br />
        <br />
        Bạn sẽ không gửi hoặc truyền bất kỳ thông điệp nào mang tính quảng cáo,
        mời gọi, thư dây chuyền, cơ hội đầu tư hay bất kỳ dạng liên lạc có mục
        đích thương mại nào mà người dùng không mong muốn, thư rác hay tin nhắn
        rác;
        <br />
        <br />
        Bạn sẽ không gửi hoặc truyền bất kỳ thông tin hoặc phần mềm nào không
        thuộc quyền sở hữu của bạn trừ khi đó là phần mềm được cung cấp miễn
        phí, khkông gửi bất kỳ thông tin hay phần mềm nào có chứa bất kỳ loại
        virus, Trojan, bọ hay các thành phần nguy hại nào;
        <br />
        <br />
        Bạn sẽ không gửi, xuất bản, truyền, tái sản xuất, phân phát hoặc khai
        thác bằng bất cứ hình thức nào với bất cứ thông tin nào thu được từ
        jlptup.com vào mục đích thương mại; hoặc tải lên, gửi, xuất bản,
        truyền, tái sản xuất hoặc phân phối dưới bất cứ hình thức nào những nội
        dung được bảo vệ bởi luật bản quyền và luật sở hữu trí tuệ của
        jlptup.com; hoặc tạo ra các biến thể của các nội dung đó mà không có sự
        đồng ý bằng văn bản của chủ nhân hoặc người giữ bản quyền.
        <br />
        <br />
        Bạn không có quyền trong và đối với thông tin được jlptup.com cung cấp
        và bạn sẽ không sử dụng thông tin trong trang web này với bất cứ hình
        thức nào hoặc bất cứ mục đích nào, trừ những điều khoản được xác lập
        trong bản Quy định sử dụng này.
        <br />
        <br />
        <span className="font-semibold text-[18px]">4. Cấm truy cập</span>
        <br />
        Chúng tôi có toàn quyền, vào mọi lúc, cấm hoặc từ chối truy cập của bạn
        vào jlptup.com hoặc bất kỳ phần nào của website ngay lập tức và không
        cần báo trước nếu chúng tôi cho rằng bạn đã vi phạm bất cứ điều khoản
        nào trong bản Quy định này, hoặc việc cấm truy cập xuất phát từ nhận
        định của chúng tôi, khi chúng tôi cho rằng từ chối đó phù hợp và cần
        thiết trong thẩm quyền của chúng tôi.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          5. Thông tin của bên thứ ba
        </span>
        <br />
        Thông tin được cung cấp tại jlptup.com có thể chứa thông tin từ bên thứ
        ba hoặc được jlptup.com chọn lọc từ các nguồn khác. Thông tin trên
        website jlptup.com không được coi là khuyến nghị sử dụng, tiêu dùng,
        đầu tư v.v…, hoặc xác thực của QSOFT.VN về bất cứ một vấn đề, biến cố
        hoặc sự kiện nào và với bất kỳ mục đích nào, tương ứng với bất kỳ người,
        sản phẩm hoặc dịch vụ nào.
        <br />
        <br />
        jlptup.com không chịu trách nhiệm nếu thông tin không được cập nhật
        theo mong muốn của bạn. website jlptup.com không phải là đơn vị độc lập
        thẩm định thông tin và sẽ không khuyến cáo bất kỳ một xu hướng tiêu dùng
        hoặc đầu tư nào. Theo đó, chúng tôi không chấp nhận bất cứ trách nhiệm
        nào về các thông tin mà chúng tôi đăng tải, bạn sẽ sử dụng hoặc đặt niềm
        tin vào những thông tin đó với hiểu biết, trách nhiệm và nguy cơ của
        riêng bạn.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          6. Liên kết đến và đi từ jlptup.com
        </span>
        <br />
        Các liên kết tại jlptup.com có thể dẫn bạn tới các website khác, và bạn
        thừa nhận và đồng ý rằng jlptup.com không chịu trách nhiệm về sự chính
        xác hoặc giá trị của bất kỳ thông tin nào do các website liên kết cung
        cấp.
        <br />
        Liên kết tới các website khác không cấu thành sự xác nhận của
        jlptup.com về thông tin, sản phẩm, quảng cáo hoặc các tài liệu khác tại
        những website đó.
        <br />
        <br />
        <span className="font-semibold text-[18px]">7. Bồi thường</span>
        <br />
        Bạn đồng ý bảo vệ, bồi hoàn và loại trừ chúng tôi cùng jlptup.com khỏi
        những nghĩa vụ pháp lý, tố tụng, tổn thất, chi phí (bao gồm cả án phí
        không giới hạn) có liên quan tới hoặc phát sinh từ sự vi phạm của bạn
        đối với bất kỳ điều khoản nào trong Quy định và/ hoặc sự sử dụng của bạn
        với website jlptup.com. Chúng tôi có thể, trong trường hợp xét thấy cần
        thiết, hoặc theo quy định của pháp luật tham gia tố tụng trước các khiếu
        kiện hoặc đàm phán để dàn xếp. Không thỏa thuận nào có thể gây ảnh hưởng
        đến quyền lợi hoặc cấu thành bổn phận của chúng tôi đối với bất kỳ tranh
        chấp nào được đưa và giải quyết cho dù chúng tôi có mặt để tham gia tố
        tụng nếu chúng tôi không đưa ra sự đồng ý bằng văn bản trước đó. Chúng
        tôi có toàn quyền, với chi phí của chúng tôi và có báo trước cho bạn,
        đảm nhận việc biện hộ và kiểm soát bất cứ khiếu kiện hoặc tố tụng nào
        nếu xét thấy cần thiết. Tuy nhiên, quyền này của chúng tôi sẽ không bị
        coi là nghĩa vụ, bao gồm nhưng không giới hạn.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          8. Quyền sở hữu trí tuệ và các quyền khác
        </span>
        <br />
        Tất cả quyền sở hữu trí tuệ tồn tại trong website jlptup.com đều thuộc
        về jlptup.com hoặc cấp phép hợp pháp cho jlptup.com sử dụng. Theo đó,
        tất cả các quyền hợp pháp đều được đảm bảo. Trừ phi được sự đồng ý của
        jlptup.com, bạn không được phép tải lên, gửi, xuất bản, tái sản xuất,
        truyền hoặc phân phát bằng bất cứ hình thức nào bất cứ thành phần nào
        của website jlptup.com hoặc tạo ra những bản sửa đổi của nội dung cung
        cấp trong jlptup.com.
        <br />
        <br />
        Tại các khu vực được phép đăng tải bài viết, bạn có thể chia sẻ thông
        tin được phép dưới các định dạng chúng tôi mặc định và bạn phải tự chịu
        trách nhiệm đối với các nội dung, thông tin, hình ảnh và bất kỳ sự chia
        sẻ nào khác của bạn với cá nhân người sử dụng hoặc nhóm người sử dụng.
        Tuy nhiên, trong mọi trường hợp, chúng tôi vẫn được bảo lưu quyền xử lý
        các thông tin đăng tải cho phù hợp với thuần phong mỹ tục, các quy tắc
        đạo đức và các quy tắc đảm bảo an ninh quốc gia, và chúng tôi có toàn
        quyền cho phép hoặc không cho phép bài viết của bạn xuất hiện hay tồn
        tại trên diễn đàn hoặc tại các khu vực được phép chia sẻ thông tin.
        <br />
        <br />
        Chúng tôi có toàn quyền, bao gồm nhưng không chỉ giới hạn trong các
        quyền tác giả, thương hiệu, bí mật kinh doanh và các quyền sở hữu khác
        mà chúng tôi có trong website jlptup.com, nội dung của website, và hàng
        hóa hoặc dịch vụ được cung cấp. Việc sử dụng quyền và sở hữu của chúng
        tôi cần phải được chúng tôi cho phép trước bằng văn bản. Ngoài việc cấp
        phép bằng văn bản, chúng tôi không cấp phép dưới bất kỳ hình thức nào
        khác cho dù đó là hình thức công bố hay hàm ý, hoặc thông qua việc để
        bạn sử dụng dịch vụ. Và do vậy, bạn không có quyền sử dụng website hoặc
        dịch vụ của chúng tôi vào mục đích thương mại mà không có sự cho phép
        bằng văn bản của chúng tôi trước đó.
        <br />
        <br />
        Bạn đồng ý để chúng tôi tự do sử dụng, tiết lộ, áp dụng và sửa đổi bất
        kỳ ý tưởng, khái niệm, cách thức, đề xuất, gợi ý, bình luận hoặc hình
        thức thông báo nào khác mà bạn cung cấp cho chúng tôi (“Phản
        hồi&amp;rdquoWink có liên quan tới jlptup.com và/hoặc dịch vụ của
        jlptup.com một cách hoàn toàn miễn phí. Bạn từ bỏ và đồng ý từ bỏ bất
        kỳ quyền và yêu cầu với bất kỳ khoản tiền thưởng, phí, nhuận bút, lệ phí
        và/ hoặc các kiểu chi trả khác liên quan đến việc chúng tôi sử dụng,
        tiết lộ, áp dụng, và/hoặc chỉnh sửa bất kỳ hoặc tất cả Phản hồi của bạn.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          9. Cung cấp Nội dung trên jlptup.com
        </span>
        <br />
        <br />
        Với việc cung cấp Nội dung cho chúng tôi:
        <br />
        <br />
        Bạn đồng ý trao cho chúng tôi toàn bộ quyền và cấp phép (bao gồm cả các
        quyền về tinh thần hay các quyền cần thiết khác) để sử dụng, trưng bày,
        tái sản xuất, chỉnh sửa, làm cho phù hợp, xuất bản, cung cấp, xúc tiến,
        dịch và tạo ra các phiên bản phái sinh hoặc tổ hợp khác, một phần hoặc
        toàn bộ, trên phạm vi toàn cầu mà không đòi hỏi thù lao. Sự cấp phép này
        được áp dụng với bất cứ dạng thức, phương tiện, công nghệ nào đã được
        biết đến hoặc phát triển sau này; bạn cần lưu ý rằng, các bài viết
        (post) trên diễn đàn, hoặc tại các khu vực được phép có thể tiếp tục nằm
        trên website của chúng tôi ngay cả khi tài khoản của bạn đã bị xóa vì
        bất kỳ lý do gì.
        <br />
        <br />
        Bạn bảo đảm rằng bạn có tất cả các quyền pháp lý, tinh thần và các quyền
        khác cần thiết để cấp phép cho chúng tôi theo điều khoản được quy định
        trong mục này;
        <br />
        <br />
        Bạn thừa nhận và đồng ý rằng chúng tôi sẽ có quyền (nhưng không có nghĩa
        vụ), từ chối xuất bản hoặc loại bỏ, hoặc ngăn truy cập tới bất kỳ Nội
        dung nào bạn cung cấp vào bất cứ lúc nào, với bất cứ lý do nào, có hoặc
        không có thông báo.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          10. Giới hạn trách nhiệm pháp lý và bảo đảm
        </span>
        <br />
        Tất cả thông tin chỉ dành cho việc tham khảo tổng quát của bạn.
        jlptup.com không nhận bất cứ trách nhiệm nào về những thông tin đó.
        <br />
        <br />
        Việc truy cập và sử dụng website jlptup.com do bạn hoàn toàn tự chịu
        trách nhiệm và được cung cấp NHƯ HIỆN CÓ. jlptup.com chỉ dành cho mục
        đích sử dụng cá nhân và chúng tôi không đại diện cho hoặc bảo đảm về bất
        cứ điều gì, được phát ngôn cụ thể hay hàm ý, bao gồm cả nhưng không chỉ
        giới hạn trong bất kỳ bảo đảm nào về khả năng thương mại hoặc sự thích
        hợp cho bất cứ mục đích cụ thể nào.
        <br />
        <br />
        Toàn bộ trách nhiệm pháp lý của chúng tôi nằm trong dịch vụ của
        jlptup.com và bị giới hạn bởi pháp luật. Chúng tôi không chứng thực,
        bảo đảm hoặc bảo hành cho bất cứ vật liệu, sản phẩm hoặc dịch vụ nào
        được đưa ra thông qua chúng tôi hoặc website của chúng tôi. Chúng tôi
        không phải là một thành phần tham gia vào bất kỳ giao dịch nào giữa bạn
        và một bên thứ ba.
        <br />
        <br />
        Trong bất kỳ trường hợp nào, jlptup.com cũng không chịu trách nhiệm
        pháp lý về bạn hoặc bất kỳ người nào cho bất kỳ tổn thất nào, dù là trực
        tiếp, gián tiếp, bất ngờ, đặc biệt hoặc là hậu quả của sự kiện khác, kể
        cả thiệt hại trong kinh doanh hoặc lợi nhuận, phát sinh từ việc sử dụng
        hoặc không thể sử dụng thông tin của jlptup.com, ngay cả khi
        jlptup.com đã được khuyến cáo về khả năng xảy ra các tổn thất đó.
        <br />
        <br />
        Bạn hành xử và tin tưởng hoàn toàn vào kỹ năng và khả năng đánh giá của
        chính bạn đối với việc sử dụng và cách hiểu đối với thông tin bạn lấy
        được tại jlptup.com. Bạn chịu trách nhiệm đảm bảo rằng việc sử dụng
        thông tin của bạn tuân thủ tất cả các yêu cầu của pháp luật hiện hành.
        <br />
        <br />
        Giới hạn nghĩa vụ pháp lý trong Quy định sẽ được áp dụng với quy mô đầy
        đủ nhất được pháp luật hiện hành cho phép.
        <br />
        <br />
        <span className="font-semibold text-[18px]">11. Từ chối bảo đảm</span>
        <br />
        <br />
        Bạn hiểu và đồng ý rằng việc bạn sử dụng jlptup.com và bất cứ dịch vụ
        hoặc nội dung nào được cung cấp trong đó (sau đây gọi chung là "Dịch
        vụ") đều thuộc phạm trù rủi ro riêng của bạn. Các dịch vụ được cung cấp
        cho bạn "như đang có" và chúng tôi từ chối mọi bảo đảm thuộc bất kỳ dạng
        nào, được hàm ý hoặc công bố, bao gồm nhưng không chỉ giới hạn trong các
        bảo hành về khả năng bán sản phẩm, sự phù hợp với một mục đích cụ thể
        nào đó, và sự không vi phạm.
        <br />
        <br />
        Chúng tôi không bảo đảm, dù hàm ý hay công bố, rằng mỗi phần của dịch vụ
        không bị gián đoạn, không có lỗi, không có virus, đúng giờ, an toàn,
        chính xác,ổn định hay bất kỳ nội dung nào là an toàn cho bạn. Bạn hiểu
        và đồng ý rằng cả chúng tôi và những bên tham gia cung cấp dịch vụ đều
        không cung cấp những tư vấn chuyên nghiệp thuộc bất kỳ dạng nào và việc
        sử dụng những lời tư vấn đó hoặc bất kỳ thông tin nào khác đều thuộc vào
        quyết định riêng của bạn, với tất cả các yếu tố rủi ro của nó và không
        thuộc trách nhiệm của chúng tôi.
        <br />
        <br />
        <span className="font-semibold text-[18px]">
          12. Thông báo về Quyền tác giả
        </span>
        <br />
        <br />
        Nếu bạn cho rằng quyền sở hữu của bạn đã bị sử dụng theo những cách thức
        vi phạm quyền tác giả, bạn có thể liên hệ với nhân viên phụ trách vấn đề
        bản quyền của chúng tôi tại địa chỉ: admin@jlptup.com.net
        <br />
        <br />
        <span className="font-semibold text-[18px]">13. Luật áp dụng</span>
        <br />
        <br />
        Bạn đồng ý rằng bản Quy định sử dụng và bất kỳ bất đồng nào phát sinh từ
        việc bạn sử dụng website này hoặc các sản phẩm và dịch vụ của chúng tôi
        sẽ được giải quyết theo luật pháp hiện hành của Nước Cộng hoà Xã hội Chủ
        nghĩa ViệtNam . Thông qua việc đăng ký hoặc sử dụng website và dịch vụ
        của chúng tôi, bạn mặc nhiên đồng ý và tuân thủ toàn bộ các quy định của
        Luật pháp Việt Nam .
        <br />
        <br />
        <span className="font-semibold text-[18px]">14. Nhiều người dùng</span>
        <br />
        Nếu có từ hai người trở lên có liên quan đến Quy định này với tư cách
        người dùng, họ sẽ chia sẻ trách nhiệm pháp lý và quyền lợi.
        <br />
        <br />
        <span className="font-semibold text-[18px]">15. Thông tin bổ sung</span>
        <br />
        <br />
        Trong trường hợp một hoặc một số điều khoản của bản Quy định sử dụng này
        xung đột với các quy định của luật pháp và bị Tòa án coi là vô hiệu,
        điều khoản đó sẽ được chỉnh sửa cho phù hợp với quy định của pháp luật
        hiện hành, và phần còn lại của Quy định sử dụng vẫn giữ nguyên giá trị;
        <br />
        <br />
        Việc bất kỳ bên nào không thể chứng minh được về quyền của mình trong
        Quy định sử dụng sẽ không bị xem là việc từ bỏ quyền của bên đó và quyền
        này vẫn còn nguyên giá trị và hiệu lực;
        <br />
        <br />
        Bạn đồng ý rằng, bất kỳ khiếu tố hoặc tố tụng nào phát sinh từ website
        này phải được đệ trình trong vòng một (1) năm sau khi khiêu tố hoặc tố
        tụng ấy phát sinh, nếu không khiếu tố sẽ hoàn toàn vô hiệu;
        <br />
        <br />
        (iv) Chúng tôi có thể chuyển nhượng quyền lợi và nghĩa vụ của mình chiểu
        theo bản Quy định sử dụng này và chúng tôi sẽ được giải phóng khỏi bất
        kỳ nghĩa vụ nào phát sinh sau đó.
        <br />
      </div>
    </Layout>
  );
}
